import Experience from '../Experience.js'
import GParticles from './GParticles.js'
import Animation from '../Animation/Animation.js'
import EarthSphere from './EarthSphere.js'
import {gsap} from 'gsap'
import { TextPlugin } from 'gsap/all'
import Country from './Country.js'
import IntPlane from './IntPlane.js'
gsap.registerPlugin(TextPlugin)

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.currentCountry = ""


        // Wait for resources
        this.resources.on('ready', () =>
        {

            this.gParticles = new GParticles()
            this.earthSphere = new EarthSphere()
            this.country = new Country()
            this.intPlane = new IntPlane()
            this.initiateInteracive()
            this.animation = new Animation()
        })


        
        
    }



    initiateInteracive = () => {
        this.intPlane.on("enter", (count, countryName, countries) => {

            this.country.particles.morph(count+1)

            gsap.to(".country", {yPercent: -5, opacity:0, autoAlpha:0, ease:'power4'}).then(() => {
                gsap.set(".country", {text:countryName}).then(() => {
                    gsap.fromTo(".country", {yPercent:5, opacity:0, autoAlpha:0}, {yPercent:0, opacity:1, autoAlpha:1, ease:'power4'})
                })
            })
            
        })
        

    }

    update()
    {
        if(this.gParticles)
            this.gParticles.update()

        if(this.intPlane){
            this.intPlane.update()
        }
    }
    
}